<template>
	<b-container class="mt-5" fluid="lg">
		<b-row>
			<b-col md="6">

				<h2>Recent Projects</h2>
				<b-card-group>
					<project-tile v-for="project in recent" v-bind:key="project.id" v-bind:value="project"></project-tile>
				</b-card-group>
            </b-col>
            <b-col md="6">
				<h2 class="">Projects
					<b-badge pill variant="dark">
						<small>({{ projects.length }})</small>
					</b-badge>
				</h2>
				<b-form-input id="filter-projects" v-model="filter" placeholder="Search projects..."></b-form-input>
				<b-card-group class="mt-2">
					<project-tile v-for="project in projects" v-bind:key="project.id" v-bind:value="project"></project-tile>
				</b-card-group>

			</b-col>

		</b-row>
	</b-container>
</template>

<style lang="scss">
@import "src/assets/variables";

.project-tile {
	min-width: 100%;
	max-width: 100%;

	+ .project-tile {
		margin-top: 1em;
	}
}
</style>

<script>
// import Autocomplete from '../components/Autocomplete'
import ProjectTile from '../components/ProjectTile'

export default {
	name: 'Home',

	components: {
		// Autocomplete,
		ProjectTile
	},

	computed: {
		recent () {
			return this.projects.slice().sort((a, b) => ( new Date(b.last_accessed) ) - ( new Date(a.last_accessed) )).slice(0, 3)
		}
	},

	data () {
		return {
			temp: {
				id: 23,
				name: 'Project Name Here',
				customer: { name: '' },
				start_date: '2020-08-13',
				end_date: '2020-11-30',
				number_products: 485395,
				number_prizes: 1855
			},

			loading: false,

			project: {
				name: '',
				customer: null,
				start_date: null,
				end_date: null
			},

			date_picker_options: {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric'
			},

			filter: '',
			projects: []
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			this.loading = !this.loading
			this.$refs['observer'].reset()

			this.$axios.post('/projects', this.project)
				.then(response => {
					this.project.name = ''
					this.project.client = {}
					this.project.start_date = null
					this.project.end_date = null
					this.loading = !this.loading

					this.$axios.post('/projects/access', { id: response.data.id })

					this.$router.push(`/projects/${response.data.id}/details`)
				})
				.catch(() => {
					this.loading = !this.loading
				})

		}
	},

	mounted () {
		this.$axios.get('/projects')
			.then(response => {
				this.projects = response.data
			})
	}
}
</script>
